export class User {
    ID!: number;
    UserName!: string;
    FirstName!: string;
    LastName!: string;
    Role!: string;
}
